<template>
    <TooltipWrapper
        ref="tooltipRef"
        class="text-left"
        :class="[
            wrapperClass,
            {
                block: showTooltip,
                hidden: !showTooltip,
            },
        ]"
    >
        <div v-if="showTitle || icon" class="flex gap-2 items-center">
            <component :is="icon" v-if="icon" :class="iconClasses" />
            <div
                v-if="showTitle"
                :class="[titleClass, { 'mb-2': showValidator }]"
            >
                {{ $t(title) }}
            </div>
        </div>

        <div v-if="showValidator" class="flex flex-col">
            <div
                v-for="(requirement, index) in requirements"
                :key="index"
                class="flex gap-3 items-start"
            >
                <div class="h-3 w-3">
                    <component
                        :is="requirement.isValid() ? 'CheckIcon' : 'XIcon'"
                        :class="{
                            'bg-lemon-green ': requirement.isValid(),
                            'bg-alert': !requirement.isValid(),
                        }"
                        class="inline-block rounded-full fill-current flex-shrink-0 text-white h-4 w-4 p-1"
                        appearence="thick"
                    />
                </div>
                <span class="text-gray-800">{{
                    $t(requirement.translationKey)
                }}</span>
            </div>
        </div>
    </TooltipWrapper>
</template>

<script>
import CheckIcon from "@/Components/Icons/CheckIcon.vue";
import XIcon from "@/Components/Icons/XIcon.vue";
import TooltipWrapper from "@/Components/Tooltips/TooltipWrapper.vue";
import { withTooltipProps, useTooltipSetup } from "@/Mixins/TooltipMixin";
import { defineComponent, computed, watchEffect } from "vue";

export default defineComponent({
    name: "PasswordRequirementsTooltip",
    components: {
        CheckIcon,
        XIcon,
        TooltipWrapper,
    },
    props: {
        ...withTooltipProps(),
        password: {
            type: String,
            required: true,
        },
        email: {
            type: String,
            required: true,
        },
    },
    emits: ["validated"],
    setup(props, { emit }) {
        const requirements = computed(() => {
            return [
                {
                    isValid: () => {
                        return props.password
                            ? props.password.toLowerCase() !==
                                  props.email.toLowerCase()
                            : false;
                    },
                    translationKey:
                        "form.password.tooltips.is_different_from_email",
                },
                {
                    isValid: () => {
                        return props.password.length >= 8;
                    },
                    translationKey: "form.password.tooltips.at_least_8_chars",
                },
                {
                    isValid: () => {
                        return props.password.match(
                            /^(?=.*[a-zA-Z])(?=.*[0-9\W])(?=.*[A-Za-z\d@$!%*#?&]).*$/
                        )
                            ? true
                            : false;
                    },
                    translationKey: "form.password.tooltips.is_alphanumeric",
                },
            ];
        });

        watchEffect(() => {
            let isValid = true;

            requirements.value.forEach((requirement) => {
                if (!requirement.isValid()) {
                    isValid = false;
                }
            });

            emit(`validated`, isValid);
        });

        return { ...useTooltipSetup(props), requirements };
    },
});
</script>
